import { UNKNOWN_DISPLAY_NAME } from "@elaso/shared/schemas/profile";
import { useStore } from "zustand";
import { authStore } from "@/lib/stores/auth-store";
import { coreStore } from "@/lib/stores/core-store";

/**
 * What the Learner Client calls the signed-in person: the name on their ELASO
 * profile, the name their account was given until that profile has loaded,
 * and their address when neither is a real name. `email` is there to show
 * beneath the name, and is `null` when the name already is the address.
 */
export function useSignedInName(): { name: string; email: string | null } {
	const user = useStore(authStore, (state) => state.user);
	const profileName = useStore(coreStore, (state) =>
		user?.uid ? state.users.get(user.uid)?.profile.displayName : undefined
	);
	const email = user?.email ?? null;
	const name = [profileName, user?.displayName].find(
		(candidate): candidate is string =>
			Boolean(candidate) &&
			candidate !== UNKNOWN_DISPLAY_NAME &&
			candidate !== email
	);
	return name ? { name, email } : { name: email ?? "User", email: null };
}
